$('document').ready(function(){
   
     $('.swatch__list_js .swatch__list--item').each(function(){
       $('body').on("mouseenter touchend",".swatch__list--item" ,function(){
         console.log(12);
     
           var find_bg1 = $(this).closest('.product-info').parent('.product-inner').find('div.pr_lazy_img.main-img').css('background-image');
           find_bg1 = find_bg1.replace('url(','').replace(')','').replace(/\"/gi, "");
           console.log(find_bg1);
        
           $(this).closest('.product-info').parent('.product-inner').find('.our-img-ctm').attr('src',find_bg1);
       
       
    
       
            
      
       
     });
       $('body').on("mouseleave touchend",".swatch__list--item" ,function(){
         console.log(12);
      
           var find_bg = $(this).closest('.product-info').parent('.product-inner').find('div.pr_lazy_img.main-img').css('background-image');
           find_bg = find_bg1.replace('url(','').replace(')','').replace(/\"/gi, "");
           console.log(find_bg);
        
           $(this).closest('.product-info').parent('.product-inner').find('.our-img-ctm').attr('src',find_bg);
       
       
    
       
            
      
       
     });
       
     
  });
 
});